import { useState } from 'react';

import LayerControl from '@App/components/MaplibreMap/LayerControl/LayerControl';
import SearchControl from '@App/components/MaplibreMap/SearchControl/SearchControl';
import CaseStudyMapCard from '@App/pages/CaseStudy/CaseStudyMapCard/CaseStudyMapCard';
import MapCard from '@App/components/MapCard/MapCard';
import MapContainer from '@App/components/MapContainer/MapContainer';
import LayerSelector from '@App/components/LayerSelector/LayerSelector';
import { useTranslation } from '@utils/i18n/i18n';

import SpeciesLayer from './SpeciesLayer/SpeciesLayer';
import ObservationsLayer from './ObservationsLayer/ObservationsLayer';

import './map.css';

function Map() {
  const { t } = useTranslation();
  const [selectedBiodiversityLayer, setSelectedBiodiversityLayer] = useState('species-per-beach');

  return (
    <CaseStudyMapCard
      className="case-study__section catalan-coast-map"
      initialCenter={[2.208767, 41.390039]}
      initialZoom={13}
      label={t('Map')}
    >
      {selectedBiodiversityLayer === 'species-per-beach' && <SpeciesLayer />}
      {selectedBiodiversityLayer === 'observations-per-beach' && <ObservationsLayer />}
      <MapContainer position="top-left">
        <MapCard className="catalan-coast-map__layer-selector">
          <LayerSelector
            title={t('Layers')}
            groups={[
              {
                title: t('Biodiversity'),
                layers: [
                  { label: t('Species per beach'), value: 'species-per-beach' },
                  { label: t('Observations per beach'), value: 'observations-per-beach' },
                ],
                selectedLayer: selectedBiodiversityLayer,
                onChange: e => setSelectedBiodiversityLayer(e.target.value),
              },
            ]}
          />
        </MapCard>
        <MapCard className="catalan-coast-map__minka-promo">
          <img src="/img/logo/minka.svg" alt={t('Minka logo')} />
          {t('Do you want to add your own observation? You can add yours on <a href=https://minka-sdg.org/ target="_blank" rel="noopener noreferrer">MINKA!</a>')}
        </MapCard>
      </MapContainer>
      <LayerControl />
      <SearchControl />
    </CaseStudyMapCard>
  );
}

export default Map;
